export class LearningOutcome {
  requestKey: string;
  name: string;

  constructor(requestKey?: string, name?: string) {
    this.requestKey = requestKey ?? '';
    this.name = name ?? '';
  }

  public setLearningOutcome(learningOutcome: {
    requestKey: string;
    name: string;
  }) {
    this.requestKey = learningOutcome.requestKey;
    this.name = learningOutcome.name;
  }

  public clearLearningOutcome() {
    this.requestKey = '';
    this.name = '';
  }
}
